// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"./colors.css\"","blue":"#00afef","grey-vlight":"#f6f6f6","blue-light":"#7fcef3"};